import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Button from '../../../core/components/Button.tsx';
import EmptyStage from '../../../core/components/EmptyStage.tsx';
import Page from '../../../core/components/Page';
import { useApplicationContext } from '../../../core/contexts/ApplicationContext.tsx';
import { canSeeAssistants } from '../../../users/utils.ts';
import AgentActivity from '../../assistants/components/activity/AgentActivity.tsx';
import { OVERVIEW_PATH as ASSISTANTS_OVERVIEW_PATH } from '../../assistants/constants.ts';

interface AgentActivityTabProps {
    mailboxId: string;
    connectedAgent: { id: string; name: string } | null;
    tabsNav: React.ReactNode;
}

const AgentActivityTab = ({ mailboxId, connectedAgent, tabsNav }: AgentActivityTabProps) => {
    const { t } = useTranslation('mailboxes');
    const { user } = useApplicationContext();

    if (!connectedAgent) {
        return (
            <>
                <Page.Header className="py-0" primary={false}>
                    <div className="flex h-full">{tabsNav}</div>
                </Page.Header>
                <Page.Content lowered className="flex flex-col gap-4">
                    <EmptyStage
                        size={88}
                        title={t('detail.activityTab.noAgent')}
                        description={t('detail.activityTab.noAgentDescription')}
                        action={
                            canSeeAssistants(user) && (
                                <Button asChild variant="primary">
                                    <Link to={ASSISTANTS_OVERVIEW_PATH}>{t('detail.activityTab.goToAssistants')}</Link>
                                </Button>
                            )
                        }
                    />
                </Page.Content>
            </>
        );
    }

    return (
        <AgentActivity
            agentId={connectedAgent.id}
            storageKey={`mailbox-${mailboxId}-activity`}
            toolbar={tabsNav}
            emptyState={
                <EmptyStage
                    size={88}
                    title={t('detail.activityTab.emptyTitle')}
                    description={t('detail.activityTab.emptyDescription')}
                />
            }
        />
    );
};

export default AgentActivityTab;
